import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from 'ui-component/Loadable';
import ProtectedRoute from './AdminProtectedRoutes';
import MainLayout from 'layout/MainLayout';
import { QsProtectedRoute } from './DepartmentProtect';


const QsDashboardPage = Loadable(lazy(() => import('views/pages/qs')));
const CertificatesPage = Loadable(lazy(() => import('views/pages/qs/Certificates')));
const CertificateDetailPage = Loadable(lazy(() => import('views/pages/qs/CertificateDetailPage')));
const QsProjectsPage = Loadable(lazy(() => import('views/pages/qs/ProjectsPage')));
const ProjectDetailPage = Loadable(lazy(() => import('views/pages/qs/ProjectDetailPage')));
const ReportsPage = Loadable(lazy(() => import('views/pages/qs/ReportsPage')));
const ClaimsPage = Loadable(lazy(() => import('views/pages/qs/ClaimsPage')));
const AccountSettings = Loadable(lazy(() => import('ui-component/account-settings')));
const AuditLogsPage = Loadable(lazy(() => import('views/pages/dashbord/utilities/AuditLog')));
const QsTeamPage =Loadable(lazy(()=>import('views/pages/qs/Team')));
const QsMemberProfilePage =Loadable(lazy(()=>import('views/pages/qs/MemberProfile')));
// ==============================|| MAIN ROUTING ||============================== //

const QsRoutes = {
    path: '/qs',
    element: (
        <QsProtectedRoute>
            <MainLayout />
        </QsProtectedRoute>
    ),
    children: [
        {
            path: '/qs',
            element: <Navigate to="/qs/dashboard" replace />
        },
        {
            path: '/qs/dashboard',
            element: <QsDashboardPage />
        },
        {
            path: '/qs/certificates',
            element: <CertificatesPage />
        },
        {
            path: '/qs/certificates/:id',
            element: (
                <ProtectedRoute
                    permissions={['certificates.read', 'certificates.update', 'certificates.review_qs', 'certificates.approve_qs']}
                >
                    <CertificateDetailPage />
                </ProtectedRoute>
            )
        },
        {
            path: '/qs/claims',
            element: <ClaimsPage />
        },
        {
            path: '/qs/projects',
            element: <QsProjectsPage />
        },
        {
            path: '/qs/team',
            element: <QsTeamPage />
        },
        {
            path: '/qs/team/:id',
            element: <QsMemberProfilePage />
        },
        {
            path: '/qs/projects/:sectorId/:slug',
            element: <QsProjectsPage />
        },

        {
            path: '/qs/projects/:id',
            element: (
                <ProtectedRoute permissions={['project_stages.read', 'project_stages.update', 'certificates.create', 'claims.create']}>
                    <ProjectDetailPage />
                </ProtectedRoute>
            )
        },
        {
            path: '/qs/account_settings',
            element: <AccountSettings />
        },
        {
            path: '/qs/reports',
            element: <ReportsPage />
        },
        {
            path: '/qs/audit-logs',
            element: (
                <ProtectedRoute roles={['super_admin', 'system_admin', 'department_head']} permissions={['audit_logs.read']}>
                    <AuditLogsPage />
                </ProtectedRoute>
            )
        }
    ]
};

export default QsRoutes;
